import axiosWrapper from '@/utils/request'

const addApplicant = (data) => {
  return axiosWrapper({
    url: `/business/applicants`,
    method: 'post',
    data
  })
}

export default {
  addApplicant
}
